export default __webpack_public_path__ + "98d0e0d7690fab5b8fadb20e20c4c891.png";